var map = {
	"./WarmPlate (1).png": "172a",
	"./WarmPlate (10).png": "bc0b",
	"./WarmPlate (11).png": "432a",
	"./WarmPlate (12).png": "169e",
	"./WarmPlate (13).png": "b3cb",
	"./WarmPlate (14).png": "5bab",
	"./WarmPlate (15).png": "5b2c",
	"./WarmPlate (16).png": "231b",
	"./WarmPlate (17).png": "628d",
	"./WarmPlate (18).png": "2170",
	"./WarmPlate (19).png": "b194",
	"./WarmPlate (2).png": "1359",
	"./WarmPlate (20).png": "a725",
	"./WarmPlate (21).png": "e419",
	"./WarmPlate (3).png": "3727",
	"./WarmPlate (4).png": "42f1",
	"./WarmPlate (5).png": "ebab",
	"./WarmPlate (6).png": "ba8d",
	"./WarmPlate (7).png": "7f3d",
	"./WarmPlate (8).png": "78c4",
	"./WarmPlate (9).png": "c7e6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ce10";